import * as React from "react";
import { memo } from "react";

import { useParams } from "react-router-dom";

import MintPage from "./index";

const MintPageByCollectionId = () => {
  const { collectionId } = useParams();
  return <MintPage collectionId={collectionId} />;
};

export default memo(MintPageByCollectionId);
